// extracted by mini-css-extract-plugin
export var cardTitle = "_j3-1";
export var commentBubble = "_j3-e";
export var commentForm = "_j3-a";
export var commentInput = "_j3-b";
export var commentLabel = "_j3-d";
export var commentPrompt = "_j3-9";
export var csatCard = "_j3-0";
export var feedbackSection = "_j3-7";
export var starDisabled = "_j3-6";
export var starEmpty = "_j3-5";
export var starFilled = "_j3-4";
export var starWrapper = "_j3-3";
export var starsContainer = "_j3-2";
export var submittedComment = "_j3-c";
export var thankYouText = "_j3-8";